import { Button, Center, Flex, TextInput } from "@mantine/core";
import { isEmail, useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { loginPasswordlessRequest } from "../../api/login.ts";
import Logo from "../../components/Icons/Logo.tsx";
import { AppRoute } from "../../constants.ts";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  const form = useForm({
    validateInputOnBlur: true,
    initialValues: {
      email: "",
    },
    validate: {
      email: isEmail("Invalid email"),
    },
  });

  const [loading, setLoading] = useState(false);

  const sendLoginLink = useCallback(() => {
    if (!form.isValid()) {
      return;
    }
    setLoading(true);
    loginPasswordlessRequest(form.values.email)
      .then((response) => {
        if (response.data.success) {
          notifications.show({
            message: "Please check your email for further instructions.",
            variant: "success",
          });
        } else {
          notifications.show({
            message: "Something went wrong. Please try again later.",
            variant: "error",
          });
        }
      })
      .catch(() => {
        notifications.show({
          message: "Something went wrong. Please try again later.",
          variant: "error",
        });
      })
      .finally(() => {
        navigate(AppRoute.Login);
      });
  }, [form, navigate]);

  return (
    <Center mx="auto" h="100vh">
      <Flex direction="column" gap={50} align="center" w="30%">
        <Logo />
        <Flex direction="column" gap={20} w="100%">
          <Flex gap={12} direction="column">
            <TextInput
              type="email"
              label="Email"
              placeholder="Enter Email"
              size="m"
              disabled={loading}
              {...form.getInputProps("email")}
            />
          </Flex>
        </Flex>

        <Button
          variant="filledBlue"
          size="md"
          w="100%"
          disabled={!form.isValid() || loading}
          loading={loading}
          onClick={sendLoginLink}
        >
          Send Login Link
        </Button>
      </Flex>
    </Center>
  );
}
